import CalendarMonth from '@mui/icons-material/CalendarMonth';
import { FormControl, IconButton, Input, InputAdornment, InputLabel, Stack, TextField, useTheme } from '@mui/material';
import { DateTimePicker, DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns';
import React, { useMemo } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import _ from 'lodash';
import useMain from 'hooks/useMain';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import moment from 'moment';

const CusDateTimePicker = React.forwardRef(({ label, onChange, onBlur, id, name, value, className, ...rest }, ref) => {
  const theme = useTheme();

  const [open, setOpen] = React.useState(false);

  const displayedValue = value ? (value[2] === '-' ? moment(value, 'DD-MM-YYYY HH:mm').toDate() : new Date(value)) : null;
  return (
    <FormControl
      fullWidth
      className={className}
      sx={{
        '.MuiInputBase-root': {
          borderRadius: '12px'
        },
        fieldset: {
          borderRadius: '12px'
        },
        '.MuiFormLabel-root': {
          color: '#446ccc',
          backgroundColor: 'white'
        }
      }}
    >
      <InputLabel id={label} shrink>
        {label}
      </InputLabel>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateTimePicker
          open={open}
          format="dd-MM-yyyy HH:mm:ss"
          views={['year', 'month', 'day', 'hours', 'minutes']}
          value={displayedValue}
          onClose={() => {
            setOpen((v) => !v);
          }}
          onChange={onChange}
          slots={{
            inputAdornment: (props) => {
              return (
                <InputAdornment position="end" sx={{ ml: 0, mr: '-12px' }}>
                  <Stack direction="row">
                    {!!value && (
                      <IconButton
                        onClick={(e) => {
                          onChange(null);
                          e.stopPropagation();
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    )}
                    <IconButton
                      onClick={(e) => {
                        setOpen((v) => !v);
                      }}
                    >
                      <CalendarMonthOutlinedIcon sx={{ color: theme.palette.primary[400] }} />
                    </IconButton>
                  </Stack>
                </InputAdornment>
              );
            }
          }}
          {...rest}
          ref={ref}
        />
      </LocalizationProvider>
    </FormControl>
  );
});

export default CusDateTimePicker;
